import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { productImage } from '../data/copy';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-deep text-white" data-id="element-255" data-mp="9lbhb4dgrhf6">
      <div className="mx-auto w-full max-w-6xl px-5 pb-10 pt-8 sm:px-6 sm:pb-16 sm:pt-12 lg:pb-24 lg:pt-16" data-id="element-256" data-mp="4mrsmw7hjrj4">
        <div className="grid items-center gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-257" data-mp="12861s1aa6gsn">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-258" data-mp="xbflpdyh7l78">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-gold/40 px-3 py-1 text-[0.7rem] font-semibold text-gold-light sm:mb-5 sm:text-xs" data-id="element-259" data-mp="nczvreb6qhzb">
              <ShieldCheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-260" data-mp="382p73hcojln9" />
              Basado en la Ley Federal FCRA
            </p>

            <h1 className="font-display text-[2rem] font-extrabold leading-[1.1] sm:text-5xl lg:text-[3.4rem]" data-id="element-261" data-mp="3j9265qny7uwl">
              Cómo limpiar tu crédito en USA y subir tu score en{' '}
              <span className="text-gold" data-id="element-262" data-mp="399bc1q3avhx1">30 días</span>
              <span className="block pt-1.5 text-lg font-semibold text-white/80 sm:pt-2 sm:text-3xl lg:text-[2rem]" data-id="element-263" data-mp="3e9fq79gqk0k3">
                (sin pagar a agencias de reparación)
              </span>
            </h1>

            <h2 className="mt-4 max-w-xl text-[1rem] leading-relaxed text-white/75 sm:mt-6 sm:text-lg" data-id="element-264" data-mp="358hmksa7lv21">
              El sistema legal <strong className="font-semibold text-white" data-id="element-265" data-mp="2qkmu9d045sph">“paso a paso”</strong>{' '}
              que los burós de crédito no quieren que conozcas para borrar deudas negativas y
              recuperar tu poder financiero.
            </h2>

            <div className="mt-6 flex flex-col items-stretch gap-3 sm:mt-9 sm:flex-row sm:items-center sm:gap-4" data-id="element-266" data-mp="2hjym2yxeimki">
              <CtaButton scrollToId="precio" data-id="element-267" data-mp="2lml8gkbazfab" />
              <p className="text-center text-sm text-white/60 sm:text-left" data-id="element-268" data-mp="s334ncg7smx0">
                <span className="text-white/40 line-through" data-id="element-269" data-mp="nat8heoiaqma">$19.00</span>{' '}
                <span className="font-semibold text-white" data-id="element-270" data-mp="ic873bxiq0w9">$6.39</span> · un solo pago, acceso de
                por vida
              </p>
            </div>

            <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[0.8rem] text-white/60 sm:mt-8 sm:justify-start sm:gap-x-7 sm:text-sm" data-id="element-271" data-mp="deq74b1haw0e">
              <li className="inline-flex items-center gap-1.5" data-id="element-272" data-mp="1622jxthu7pgi">
                <DownloadIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-273" data-mp="15zq2dhfzrh3z" />
                Descarga instantánea
              </li>
              <li className="inline-flex items-center gap-1.5" data-id="element-274" data-mp="x1nuqj1r5q7q">
                <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-275" data-mp="x37b09nes19i" />
                Pago seguro
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative order-first mx-auto w-full max-w-[240px] sm:max-w-xs lg:order-none lg:max-w-none" data-id="element-276" data-mp="3hqam6y4cdrp9">
            <img src={productImage} alt="Tablet mostrando la portada de la guía Crédito Limpio en 30 Días" className="w-full rounded-xl shadow-lift" width={1024} height={1024} data-id="element-277" data-mp="268obzltdvbtl" />
          </motion.div>
        </div>
      </div>
    </header>;
}